//Status view template for interior of step. Most of the magic happens in its child component, ReceiptStatus, that it shares with the status page template.
import React from "react"
import ReceiptStatus from "./ReceiptStatus"
import ReceiptViewHeader from "./ReceiptViewHeader"

const StatusView = ({ status="submitted", headline = "Receipt Submission Status", reward={}, onStatusRetrieved }) => {
  

  // const { text, icon } = statusOptions[status] || {}
  return (
    <div className="receipt-view upload-view">
      <ReceiptViewHeader headline={headline} headerImage={ reward && reward.rewardImage }  />
      <div className={`receipt-view-content`}>
        <ReceiptStatus status={status } onStatusRetrieved={onStatusRetrieved} />
      </div>
    </div>
  )
}
export default StatusView
